import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import TechniciansAPI from '@/services/api/internal/technicians.api';

export function findTechByGroupId(groupId) {
  const q = {
    $and: [
      {
        user_gid: { $eq: groupId },
      },
      {
        $or: [
          {
            end_date: {
              $gte: { $date: new Date().toISOString() },
            },
          },
          {
            end_date: { $null: null },
          },
          {
            end_date: {
              $lte: { $date: '1000-01-01T00:00:00.000Z' },
            },
          },
        ],
      },
    ],
  };
  return TechniciansAPI.getItems({
    params: { q },
  })
    .then((response) => {
      const item = response.data.items[0];
      if (item) return item;
      throw new Error(`User ${groupId} is not in P2H_personnels`);
    })
    .catch(errorHandler);
}

export function directReport(requestId, body) {
  const url = `${process.env.P2C_BASE_URI}/requests/${requestId}/direct_report`;
  return Client.put(url, body).catch(errorHandler);
}
